<template>
	<div class="drag-container">
		<ul class="drag-list">
			<li
				style="box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24); transition: all 0.3s cubic-bezier(.25,.8,.25,1);"
				v-for="stage in stages"
				:key="stage.id"
				class="drag-column"
				:class="{ ['drag-column-' + stage.status]: true }"
			>
				<span>
					<slot name="header" :stage="stage" :stages="stages"></slot>
				</span>
				<div class="drag-options"></div>
				<ul
					class="drag-inner-list"
					ref="list"
					:data-status="stage.status"
					:data-stage-entityId="stage.entityId"
				>
					<li
						class="drag-item"
						v-for="(block, index) in getBlocks(stage.status)"
						:data-block-entityId="block.entityId"
						:data-block-id="block.id"
						:key="block.id"
						:index="index"
					>
						<slot
							name="block-item"
							:stage="stage"
							:stages="stages"
							:block="block"
						></slot>
					</li>
				</ul>
				<slot name="footer" :stage="stage" :stages="stages"></slot>
			</li>
		</ul>
	</div>
</template>

<script>
	import dragula from "dragula";
	import { Machine } from "xstate";

	export default {
		name: "KanbanBoard",
		props: {
			stages: {
				type: Array,
				required: true,
			},
			blocks: {
				type: Array,
				required: true,
			},
			config: {
				type: Object,
				default: () => ({}),
			},
			stateMachineConfig: {
				type: Object,
				default: null,
			},
		},

		data() {
			return {
				movingBlock: {
					blockId: null,
					previousBlockId: null,
					nextBlockId: null,
					currentBlockStage: null,
					nextBlockStage: null,
					currentBlockIndex: null,
					nextBlockIndex: null,
					nextStageId: null,
					currentStageId: null,
				},
				previousBlock: null,
				currentBlock: null,
				nextBlock: null,
				entityId: null,
				currentIndex: null,
				nextIndex: null,
				itemSelected: null,
				jobSelected: {},
				statusSelected: "",
				jobStatus: [],
				machine: null,
				rollBackList: null,
			};
		},

		watch: {
			blocks() {
				// if (value.length == 0) alert("teste");
			},
		},
		computed: {
			localBlocks() {
				return this.blocks;
			},
		},

		methods: {
			getBlocks(status) {
				return this.blocks.filter((block) => block.status === status);
			},

			findPossibleTransitions(sourceState) {
				return this.machine.config.states[sourceState].on || {};
			},

			findTransition(target, source) {
				const targetState = target.dataset.status;
				const sourceState = source.dataset.status;
				const possibleTransitions = this.findPossibleTransitions(sourceState);
				return Object.keys(possibleTransitions).find(
					(transition) => possibleTransitions[transition] === targetState
				);
			},

			accepts(block, target, source) {
				if (!this.machine) return true;
				const targetState = target.dataset.status;
				const sourceState = source.dataset.status;
				return Object.values(
					this.findPossibleTransitions(sourceState)
				).includes(targetState);
			},
			getBlockIsMovingByList(list) {
				for (let index = 0; index < list.children.length; index += 1) {
					console.log(list.children[index]);
					return this.getBlockIsMoving(list.children[index]);
				}
			},

			updatedBlocks() {
				this.blocks.length = 0;
			},
			updateComponent() {
				Object.assign(this.$data, this.$options.data.call(this));
			},
			createDragula() {
				this.config.accepts = this.config.accepts || this.accepts;
				this.drake = dragula(this.$refs.list, this.config)
					.on("drag", (el, list) => {
						el.classList.add("is-moving");
						this.movingBlock.currentBlockStage =
							list.attributes["data-status"].value;
						this.movingBlock.currentBlockIndex = [...list.children].indexOf(el);
						this.movingBlock.blockId =
							el.attributes["data-block-entityId"].value;
						this.movingBlock.currentStageId =
							list.attributes["data-stage-entityId"].value;
						this.$emit("block-id-selected", this.movingBlock.blockId);
					})
					.on("drop", (block, list, source) => {
						let blocksLi = [...list.children];
						this.movingBlock.nextStageId =
							list.attributes["data-stage-entityId"].value;
						this.movingBlock.nextBlockStage =
							list.attributes["data-status"].value;
						this.movingBlock.nextBlockIndex = blocksLi.indexOf(block);
						let previousBlockLi = blocksLi[this.movingBlock.nextBlockIndex - 1];
						let nextBlockLi = blocksLi[this.movingBlock.nextBlockIndex + 1];

						if (previousBlockLi)
							this.movingBlock.previousBlockId =
								blocksLi[this.movingBlock.nextBlockIndex - 1].attributes[
									"data-block-entityId"
								].value;

						if (nextBlockLi)
							this.movingBlock.nextBlockId =
								blocksLi[this.movingBlock.nextBlockIndex + 1].attributes[
									"data-block-entityId"
								].value;

						let newState = list.dataset.status;
						newState;

						if (this.machine) {
							const transition = this.findTransition(list, source);
							if (!transition) return;
							newState = this.machine.transition(
								source.dataset.status,
								transition
							).value;
						}

						this.$emit(
							"update-block",
							this.movingBlock,
							this.blocks.find((b) => b.entityId == this.movingBlock.blockId)
						);
					})
					.on("dragend", (el) => {
						el.classList.remove("is-moving");

						window.setTimeout(() => {
							el.classList.add("is-moved");
							window.setTimeout(() => {
								el.classList.remove("is-moved");
							}, 600);
						}, 100);

						this.movingBlock = {};
					});
			},
		},

		updated() {
			if (this.$refs.list) this.drake.containers = this.$refs.list;
		},

		mounted() {
			this.config.accepts = this.config.accepts || this.accepts;
			this.createDragula();
		},

		created() {
			if (!this.stateMachineConfig) return;
			this.machine = Machine(this.stateMachineConfig);
		},
	};
</script>
